import nxModule from 'nxModule';
import fingerprintService from '../../../react/system/fingerprintService';

nxModule.factory('fingerprintService', () => fingerprintService);
